import moment from 'moment';

export const getFormattedTime = epochTime => {
    return moment.unix(epochTime).format('MM/DD/YYYY - hh:mma');
};
